import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { retry, tap } from 'rxjs';
import { LoggingService } from '../services';

const NUMBER_OF_TRIALS = 3;

@Injectable()
export class RetryInterceptor implements HttpInterceptor {
  loggingService = inject(LoggingService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    let trialCount = 0;
    return next.handle(request).pipe(
      retry(NUMBER_OF_TRIALS),
      tap((request) => {
        trialCount++;
        if (
          request instanceof HttpRequest &&
          trialCount > 1 &&
          !request.url.includes('.json') &&
          !request.url.includes('/details')
        ) {
          this.loggingService.log('Retry(' + trialCount + '):\n');
          this.loggingService.log(request);
        }
      }),
    );
  }
}
